export default __webpack_public_path__ + "static/media/property_507.5189ae31.png";